import React from 'react';
import './preview-header.sass';
import logoImageBig from '../../assets/preview/Logo_header_big.png';
import logoImageSmall from '../../assets/preview/Logo_header_small.png';
import { useHistory } from 'react-router-dom';
import { Config } from '../../../../config/config';

export const PreviewHeaderType = {
  DEFAULT: 'default',
  BACKS_STREET_BOYS: 'BACKS_STREET_BOYS'
};

export const PreviewHeader = ({type = PreviewHeaderType.DEFAULT}) => {

    const history = useHistory();

    return (
      <div className='vv-preview-header-container'>
          <div className='vv-preview-header'>
              <div/>
              <picture>
                  <source media='(max-width: 919px)' srcSet={logoImageSmall}/>
                  <img className='vv-preview-header__image' src={logoImageBig} alt='ViceVersa'/>
              </picture>
              <div>
                {type === PreviewHeaderType.DEFAULT ?
                  <span onClick={() => history.push(Config.routePaths.main.vendor.path)}>Dla partnerów</span> :
                  <span onClick={() => history.push(Config.routePaths.main.path)}>kim jesteśmy?</span>
                }
              </div>
          </div>
      </div>
  );
};
